import { createFileRoute } from '@tanstack/react-router'
import { ComplianceAuditTool } from '@/features/compliance-audit/components'
import { getTranslations } from '@/i18n/translator'
import { pageHead, SITE_URL } from '@/lib/seo'
import { breadcrumbSchema, homeBreadcrumbItem, softwareApplicationSchema } from '@/lib/structured-data'

export const Route = createFileRoute('/$locale/tools/compliance-audit')({
  loader: async ({ params }) => {
    const t = await getTranslations({ locale: params.locale, namespace: 'complianceAudit' })
    return { title: t('title'), description: t('subtitle') }
  },
  head: ({ loaderData, params }) => {
    const path = '/tools/compliance-audit'
    const url = `${SITE_URL}/${params.locale}${path}`
    const title = loaderData?.title ?? ''
    const description = loaderData?.description ?? ''
    return pageHead({
      locale: params.locale,
      path,
      title,
      description,
      jsonLd: [
        breadcrumbSchema([homeBreadcrumbItem(params.locale), { name: title, url }]),
        softwareApplicationSchema({ name: title, description, url }),
      ],
    })
  },
  component: Page,
})

function Page() {
  return (
    <div className="flex h-full flex-col items-center justify-center py-8">
      <ComplianceAuditTool />
    </div>
  )
}
